// Copyright Open Trade Technology Ltd. 2023. All rights reserved.

import { chainIdToChainConfigurationValues, testAssetChains } from './DeploymentConfigsDefaults'
import { StageConfiguration } from './DeploymentConfigTypes'
import { ChainConfiguration } from './DeploymentConfigTypes'
import { ChainId } from './Enums'

const LYT_DEV_FUJI_SERVICE_CONFIGURATION_ADDR = '0x3777Db8a016d4B2c44ba5117A65Fcda3DEc6e33c'

const cognitoRegion = 'us-east-1'
const cognitoOTUserPoolId = 'us-east-1_CEHVW3KZf' // IN Production these are 2 different pools
const cognitoLytUserPoolId = 'us-east-1_uM41RLrBr'

const DEV_SEPOLIA_FRONTEND_URL = 'https://eth-sepolia.g.alchemy.com/v2/eiPlOW8JsDv6XX2Nx7pNM'
const DEV_SEPOLIA_BACKEND_URL = 'https://eth-sepolia.g.alchemy.com/v2/T7jthncxhDOfM0ZNo05Hd'
const DEV_FUJI_FRONTEND_URL = 'https://avax-fuji.g.alchemy.com/v2/8PA73IMpIFVh6JJWT73vE'
const DEV_FUJI_BACKEND_URL = 'https://avax-fuji.g.alchemy.com/v2/TY9d7HjOrUmauijGrBvF3'

// WebSocket URLs
const DEV_SEPOLIA_FRONTEND_WS_URL = 'wss://eth-sepolia.g.alchemy.com/v2/eiPlOW8JsDv6XX2Nx7pNM'
const DEV_FUJI_FRONTEND_WS_URL = 'wss://avax-fuji.g.alchemy.com/v2/8PA73IMpIFVh6JJWT73vE'

// Protocol address

const DEV_SEPOLIA_SERVICE_CONFIGURATION_ADDR = '0x2D2a27C3a778414DaD4Db79589e83725184aC64B'
const DEV_FUJI_SERVICE_CONFIGURATION_ADDR = '0xbEe469ECA2aC896154A224826521aE74b24D370B'
const DEV_PLUME_TESTNET_SERVICE_CONFIGURATION_ADDR = '0x314869E236c2BFb7827c3b882C7473F541f535F2'

const WALLET_CONNECT_DEV_PROJECT_ID = '9c66a40540005698d2ccabbb3a734523'

// REST_API_KEYS
const DEV_REST_API_KEY = 'jKTM0DiPDmaIMHmzcCtzL6yjqMvSgBAaYEr6B5Y7'

const CHAIN_CONFIG_DEV_FUJI: ChainConfiguration = {
  ...chainIdToChainConfigurationValues(ChainId.FUJI),
  chainConfigurationName: 'DevFuji',
  serviceConfigurationAddr: DEV_FUJI_SERVICE_CONFIGURATION_ADDR,
  frontendProviderUrl: DEV_FUJI_FRONTEND_URL,
  frontendWebSocketProviderUrl: DEV_FUJI_FRONTEND_WS_URL,
  backendProviderUrl: DEV_FUJI_BACKEND_URL,
  walletConnectProjectId: WALLET_CONNECT_DEV_PROJECT_ID,
}

const CHAIN_CONFIG_LYT_DEV_FUJI: ChainConfiguration = {
  ...chainIdToChainConfigurationValues(ChainId.FUJI),
  chainConfigurationName: 'LytDevFuji',
  serviceConfigurationAddr: LYT_DEV_FUJI_SERVICE_CONFIGURATION_ADDR,
  frontendWebSocketProviderUrl: DEV_FUJI_FRONTEND_WS_URL,
  walletConnectProjectId: WALLET_CONNECT_DEV_PROJECT_ID,
}

const CHAIN_CONFIG_DEV_PLUME_TESTNET: ChainConfiguration = {
  ...chainIdToChainConfigurationValues(ChainId.PLUME_TESTNET),
  chainConfigurationName: 'DevPlume',
  serviceConfigurationAddr: DEV_PLUME_TESTNET_SERVICE_CONFIGURATION_ADDR,
  walletConnectProjectId: WALLET_CONNECT_DEV_PROJECT_ID,
}

const CHAIN_CONFIG_DEV_SEPOLIA: ChainConfiguration = {
  ...chainIdToChainConfigurationValues(ChainId.SEPOLIA),
  chainConfigurationName: 'DevSepolia',
  serviceConfigurationAddr: DEV_SEPOLIA_SERVICE_CONFIGURATION_ADDR,
  frontendProviderUrl: DEV_SEPOLIA_FRONTEND_URL,
  frontendWebSocketProviderUrl: DEV_SEPOLIA_FRONTEND_WS_URL,
  backendProviderUrl: DEV_SEPOLIA_BACKEND_URL,
  walletConnectProjectId: WALLET_CONNECT_DEV_PROJECT_ID,
}

export const DEVOTTO_STAGE_CONFIG: StageConfiguration = {
  stageName: 'devotto', // from serverless.yml
  domain: 'app.opentradedevotto.com',
  websocketUrl: 'wss://ws.opentradedevotto.com',
  serverApiBaseUrl: 'https://api.opentradedevotto.com',
  graphqlUrl: 'https://gql.opentradedevotto.com',
  restAPIKey: DEV_REST_API_KEY,
  supportedChains: testAssetChains,
  chainConfigurations: [CHAIN_CONFIG_DEV_SEPOLIA, CHAIN_CONFIG_DEV_FUJI, CHAIN_CONFIG_DEV_PLUME_TESTNET],
  userConnections: [],
  cognitoConfig: {
    clientId: '1i417bmld3u3s369mtc0qukpiu',
    userPoolId: cognitoOTUserPoolId,
    region: cognitoRegion,
  },
  isLyt: false,
}

export const DEVTOM_STAGE_CONFIG: StageConfiguration = {
  stageName: 'devtom', // from serverless.yml
  domain: 'app.opentradedevtom.com',
  websocketUrl: 'wss://ws.opentradedevtom.com',
  serverApiBaseUrl: 'https://api.opentradedevtom.com',
  graphqlUrl: 'https://gql.opentradedevtom.com',
  restAPIKey: DEV_REST_API_KEY,
  supportedChains: testAssetChains,
  chainConfigurations: [CHAIN_CONFIG_DEV_SEPOLIA, CHAIN_CONFIG_DEV_FUJI, CHAIN_CONFIG_DEV_PLUME_TESTNET],
  userConnections: [],
  cognitoConfig: {
    clientId: '47739008flkps0ghfksfsj70s2',
    userPoolId: cognitoOTUserPoolId,
    region: cognitoRegion,
  },
  isLyt: false,
}

export const DEV_STAGE_CONFIG: StageConfiguration = {
  stageName: 'dev', // from serverless.yml
  domain: 'app.opentradedev.com',
  websocketUrl: 'wss://ws.opentradedev.com',
  serverApiBaseUrl: 'https://api.opentradedev.com',
  graphqlUrl: 'https://gql.opentradedev.com',
  restAPIKey: DEV_REST_API_KEY,
  supportedChains: testAssetChains,
  chainConfigurations: [CHAIN_CONFIG_DEV_SEPOLIA, CHAIN_CONFIG_DEV_FUJI, CHAIN_CONFIG_DEV_PLUME_TESTNET],
  userConnections: [],
  cognitoConfig: {
    clientId: '1t68q9od6miimtq6im98c417qr',
    userPoolId: cognitoOTUserPoolId,
    region: cognitoRegion,
  },
  isLyt: false,
}

export const DEV_LYT_STAGE_CONFIG: StageConfiguration = {
  stageName: 'devsierra', // from serverless.yml
  domain: 'app.sierradevapp.com',
  websocketUrl: 'wss://ws.sierradevapp.com',
  serverApiBaseUrl: 'https://api.sierradevapp.com',
  graphqlUrl: 'https://gql.sierradevapp.com',
  lytPoolAddr: '0x1941f8fC7545F4dc1A735AB73fec0eE8B4D97d07',
  restAPIKey: DEV_REST_API_KEY,
  supportedChains: [{ name: 'Fuji', chain: 'Fuji', chainID: ChainId.FUJI, rpcUrl: DEV_FUJI_FRONTEND_URL }],
  chainConfigurations: [CHAIN_CONFIG_LYT_DEV_FUJI],
  userConnections: [],
  cognitoConfig: {
    clientId: '31mjq2fitlq1i1ska66fcvsoir',
    userPoolId: cognitoLytUserPoolId,
    region: cognitoRegion,
  },
  parentStageConfiguration: DEV_STAGE_CONFIG,
  parentChainConfiguration: CHAIN_CONFIG_DEV_FUJI,
  isLyt: true,

  oftAdapter: '0x8B9DCCf3B8d5F1dC9F2Ab9f34cA8dc674FfDe6Ae',
  layerZeroEid: 40106, // AVALANCHE_V2_TESTNET (Fuji)
}
